<template>
  <div class="foottxt">
    <b>上海色宁</b><a href="http://www.shsening.com/" target="_blank"><i> www.shsening.com</i></a>
  </div>
</template>

<script>
  export default {
    name: "LayoutFooter",
    data() {
      return {};
    },
    methods: {

    }
  };

</script>

<style scoped>
  .foottxt {
    text-align: right;
    font: 12px Extra Extra Small;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/LayoutFooter.vue